import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48849d84"
import script from "./?vue&type=script&lang=js&external"
export * from "./?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports